// extracted by mini-css-extract-plugin
export default {"buttons":"PlaybackButtons_buttons__lFlaw"};